import * as yup from 'yup';

import { reportToDate, msisdnValidationSimple } from '../../../../../../../constants/validation';
import { FORM_INPUT_ERROR_MSGS } from '../../../../../../../constants/errors';

export const validationSchema = yup.object().shape({
  from: yup
    .date()
    .required(FORM_INPUT_ERROR_MSGS.REQUIRED('Starting date'))
    .typeError(FORM_INPUT_ERROR_MSGS.INVALID_FORMAT('Starting date')),
  to: reportToDate,
  acquirerMsisdns: yup.array(msisdnValidationSimple)
});
